export default __webpack_public_path__ + "41697acead6bfa26de14ee22803afdee.svg";